import { Semver } from '../../utils/Semver';
export function greaterThanEqualToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver(ruleAttr);
    return function greaterThanEqualToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver(runtimeAttr);
        var isGreaterThanEqual = runtimeSemver.compare(ruleSemver) >= 0;
        return isGreaterThanEqual;
    };
}
